import { render } from "./compare.vue?vue&type=template&id=b7f5063e&scoped=true"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"

import "./compare.vue?vue&type=style&index=0&id=b7f5063e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f5063e"]])

export default __exports__